export default __webpack_public_path__ + "static/media/Group 8447.550dcb21.png";